import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const NAMES = { terms: "Terms of Service", privacy: "Privacy Policy", community: "Community Guidelines", age: "Age requirement (18+)", ai_processing: "AI processing notice" };
const LINKS = { terms: "/legal/terms", privacy: "/legal/privacy", community: "/legal/community", age: "/legal/terms", ai_processing: "/legal/privacy" };

export const ConsentSection = () => {
  const [data, setData] = useState(null);
  const load = () => api.get("/consents").then(({ data }) => setData(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  if (!data) return null;
  const marketing = data.consents.find((c) => c.policy_type === "marketing");
  const setMarketing = async (v) => {
    try { await api.put("/consents/marketing", { accepted: v }); load(); toast.success(v ? "Subscribed to product updates." : "Unsubscribed."); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="panel p-6 sm:p-8 space-y-5" data-testid="settings-consents">
      <h2 className="text-lg font-semibold">Policies you've accepted</h2>
      <div className="divide-y divide-border">
        {Object.entries(data.current_versions).map(([k, v]) => {
          const rec = data.consents.find((c) => c.policy_type === k && c.policy_version === v && c.accepted);
          return (
            <div key={k} className="flex items-center justify-between gap-3 py-3 text-sm" data-testid={`settings-consent-${k}`}>
              <Link to={LINKS[k]} className="font-medium hover:text-primary">{NAMES[k]} <span className="text-xs text-muted-foreground">v{v}</span></Link>
              <span className="text-xs text-muted-foreground">{rec ? `Accepted ${new Date(rec.accepted_at).toLocaleString()}` : "Not accepted"}</span>
            </div>
          );
        })}
      </div>
      <div className="flex items-start justify-between gap-4">
        <div><div className="text-sm font-medium">Product update emails</div><div className="text-xs text-muted-foreground">Optional, separate from required policies.</div></div>
        <Switch data-testid="settings-marketing-switch" checked={!!marketing?.accepted} onCheckedChange={setMarketing} />
      </div>
    </section>
  );
};
